/* angular:styles/component:css;5a0ff34f8bbc85ecc86d36ecb01eae1d130596f17d87a01e734784c8aca1f44a;/src/src/app/shared/components/schedule/edit/edit-task.component.ts */
::ng-deep formly-form {
  height: 100% !important;
}
/*# sourceMappingURL=edit-task.component.css.map */
